import { d as s, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as n, normalizeClass as c, normalizeStyle as r, createElementVNode as l } from "vue";
const a = s("ask2"), i = /* @__PURE__ */ l("path", {
  d: "M512 1024C228.43 1024 0 795.57 0 512S228.43 0 512 0s512 228.43 512 512-228.43 512-512 512zm0-945.23C273.067 78.77 78.77 273.066 78.77 512S273.066 945.23 512 945.23 945.23 750.934 945.23 512 750.934 78.77 512 78.77zm0 525.127c-21.005 0-39.385-18.38-39.385-39.384v-44.636c0-26.256 18.38-49.887 44.636-52.513 13.128-2.626 18.38-2.626 18.38-2.626 23.63-10.502 39.384-34.133 39.384-57.764 0-34.133-28.882-63.015-65.64-63.015s-65.642 28.882-65.642 63.015c0 21.005-18.38 39.385-39.384 39.385s-36.76-18.38-36.76-42.01c0-78.77 65.642-141.785 144.411-141.785S656.41 325.58 656.41 404.35c0 57.764-34.133 110.277-89.272 131.282-5.25 2.625-10.502 2.625-15.753 5.251v23.63c0 21.006-18.38 39.385-39.385 39.385zm-65.641 118.154a65.641 65.641 0 1 0 131.282 0 65.641 65.641 0 1 0-131.282 0Z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), m = [
  i
];
function p(e, _, d, f, u, v) {
  return t(), n("svg", {
    class: c(e.classes),
    style: r(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, m, 6);
}
const z = /* @__PURE__ */ o(a, [["render", p]]);
export {
  z as default
};
